import { useState } from 'react';
import { Link, useNavigate } from 'react-router-dom';
import { comics } from '@/mocks/comics';

export default function Hero() {
  const featured = comics[0];
  const hotPicks = comics.filter((c) => c.hot).slice(0, 4);
  const [keyword, setKeyword] = useState('');
  const navigate = useNavigate();

  const onSearch = (e: React.FormEvent) => {
    e.preventDefault();
    navigate(keyword.trim() ? `/comics?q=${encodeURIComponent(keyword.trim())}` : '/comics');
  };

  return (
    <section className="relative overflow-hidden">
      <div className="absolute inset-0">
        <img
          src="https://readdy.ai/api/search-image?query=epic%20fantasy%20meteor%20shower%20over%20a%20dark%20mountain%20city%20with%20a%20lone%20hero%20silhouette%20holding%20a%20glowing%20star%2C%20gold%20and%20orange%20starlight%20beams%20cutting%20through%20night%20sky%2C%20dramatic%20cinematic%20composition%2C%20anime%20style%20wide%20illustration%2C%20rich%20atmosphere%2C%20high%20detail%2C%20energetic%20and%20epic%20mood&width=1600&height=900&seq=hero-main&orientation=landscape"
          alt="麻瓜漫画网首页推荐场景"
          className="h-full w-full object-cover object-top"
        />
        <div className="absolute inset-0 bg-gradient-to-b from-black/60 via-black/50 to-background-50"></div>
        <div className="absolute inset-0 halftone-soft opacity-30"></div>
      </div>

      <div className="relative mx-auto max-w-7xl px-4 md:px-6 pt-32 md:pt-44 pb-20 md:pb-28">
        <div className="flex flex-col items-center text-center">
          <span className="inline-flex items-center gap-2 rounded-full bg-accent-500/20 px-4 py-1.5 text-xs font-semibold text-accent-400 ring-1 ring-accent-500/40 whitespace-nowrap">
            <i className="ri-fire-fill"></i>
            原版漫画 · 每日更新 · 畅快追更
          </span>

          <h1 className="mt-6 font-heading text-4xl md:text-6xl text-foreground-950 text-balance max-w-4xl">
            原汁原味的 <span className="text-primary-500">原版漫画</span>，一网打尽
          </h1>

          <p className="mt-5 max-w-2xl text-sm md:text-base leading-7 text-foreground-800">
            收录高清完整版、未删减原版与导演剪辑版漫画，覆盖奇幻、都市、科幻、武侠等热门题材。
            完整剧情一话不少，直接追更不折腾。
          </p>

          <form onSubmit={onSearch} className="mt-8 w-full max-w-xl">
            <div className="flex items-center gap-2 rounded-full bg-background-100/80 p-2 ring-1 ring-background-300/60 backdrop-blur-sm">
              <i className="ri-search-line pl-3 text-foreground-500"></i>
              <input
                type="text"
                value={keyword}
                onChange={(e) => setKeyword(e.target.value)}
                placeholder="搜索想看的漫画"
                className="h-11 flex-1 bg-transparent text-sm text-foreground-950 placeholder:text-foreground-400 outline-none"
              />
              <button
                type="submit"
                className="h-11 shrink-0 rounded-full bg-primary-500 px-6 text-sm font-semibold text-background-50 hover:bg-primary-600 whitespace-nowrap"
              >
                立即搜索
              </button>
            </div>
          </form>

          <div className="mt-7 flex flex-wrap items-center justify-center gap-3">
            <Link
              to="/comics"
              className="h-11 flex items-center gap-2 rounded-full bg-primary-500 px-6 text-sm font-semibold text-background-50 hover:bg-primary-600 whitespace-nowrap"
            >
              <i className="ri-book-open-line"></i>
              浏览漫画大全
            </Link>
            <Link
              to={`/comic/${featured.id}`}
              className="h-11 flex items-center gap-2 rounded-full bg-background-100/80 px-6 text-sm font-semibold text-foreground-950 ring-1 ring-background-300/60 hover:bg-background-200 whitespace-nowrap"
            >
              <i className="ri-play-circle-line text-primary-500"></i>
              立即阅读
            </Link>
          </div>

          <div className="mt-10 flex flex-wrap items-center justify-center gap-6 text-center">
            {[
              { num: '1,200+', label: '收录漫画' },
              { num: '10', label: '题材分类' },
              { num: '24h', label: '实时更新' },
              { num: '100%', label: '原版完整' },
            ].map((s) => (
              <div key={s.label}>
                <p className="font-heading text-2xl text-accent-500">{s.num}</p>
                <p className="mt-1 text-xs text-foreground-600">{s.label}</p>
              </div>
            ))}
          </div>
        </div>

        {/* featured covers strip */}
        <div className="mt-14 grid grid-cols-4 gap-3 md:gap-5 max-w-3xl mx-auto">
          {hotPicks.map((c, i) => (
            <Link key={c.id} to={`/comic/${c.id}`} className="group">
              <div className="relative aspect-[3/4] overflow-hidden rounded-lg ring-1 ring-background-300/50">
                <img
                  src={c.cover}
                  alt={`${c.title} 推荐封面`}
                  title={c.title}
                  loading="lazy"
                  className="h-full w-full object-cover object-top transition-transform duration-500 group-hover:scale-105"
                />
                <div className="absolute inset-0 bg-gradient-to-t from-black/70 to-transparent"></div>
                <span className="absolute left-1.5 top-1.5 flex h-5 w-5 items-center justify-center rounded-md bg-primary-500 text-[11px] font-bold text-background-50">
                  {i + 1}
                </span>
                <p className="absolute bottom-1.5 left-1.5 right-1.5 truncate text-xs font-semibold text-foreground-950">
                  {c.title}
                </p>
              </div>
            </Link>
          ))}
        </div>
      </div>
    </section>
  );
}